import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  connect() {
    this.modal = new Modal(this.element);
    this.handleImageLoadingInModal();
  }

  handleFrameLoad() {
    // Handle image loading after turbo frame loads
    this.handleImageLoadingInModal();
  }

  handleImageLoadingInModal() {
    // Ensure images have proper error handling and retry logic
    const images = this.element.querySelectorAll('img[data-image-rotation-target]');
    images.forEach(img => {
      if (!img.complete || img.naturalWidth === 0) {
        // Add loading indicator while image loads
        const loadingDiv = document.createElement('div');
        loadingDiv.className = 'text-center text-muted small';
        loadingDiv.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Loading image...';
        img.parentNode.insertBefore(loadingDiv, img);

        img.addEventListener('load', () => {
          loadingDiv.remove();
        });

        img.addEventListener('error', () => {
          loadingDiv.innerHTML = '<i class="fas fa-exclamation-triangle"></i> Image temporarily unavailable';
          console.warn('Image failed to load in modal:', img.src);
        });
      }
    });
  }

  close() {
    if (this.element.dataset.targetUpdate) {
      document.querySelector(this.element.dataset.targetUpdate).value = 
        document.querySelector(this.element.dataset.sourceUpdate).value;
    }

    // Clean up the modal instance
    if (this.modal) {
      this.modal.hide();
      this.modal.dispose();
    }

    // Remove the backdrop if it exists
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }

    // Properly clear the turbo frame
    const turboModal = document.getElementById("turbo_modal");
    if (turboModal) {
      turboModal.removeAttribute("src");
      turboModal.innerHTML = ""; // Clear the content so Turbo will reload it next time
    }

    // Remove the modal element if not configured to keep it
    if (this.element.dataset.removeModal !== "false") {
      this.element.remove();
    }

    $(".form-submit").each(function () {
      const element = $(this);
      Rails.enableElement(element[0]);
      element.html(element.data("originalMsg"));
    });
    const element = $("#license-plate-form-submit");
    if (element[0]) {
      Rails.enableElement(element[0]);
      element.html(element.data("originalMsg"));
    }
  }

  escClose(event) {
    if (event.key === "Escape") this.close();
  }
}
